/* globals Raven */

import React from "react";
import { Query } from "react-apollo";
import * as R from "ramda";

import { Spin } from "antd";

import { isAuthenticated } from "../api/auth";
import queries from "../api/queries";

const WithAuth = WrappedComponent => {
    const component = props => (
        <Query query={queries.GET_AUTH_TOKENS}>
            {({ loading, data }) => {
                const accessTokenPayload = R.path(
                    ["auth", "accessToken"],
                    data
                );
                const refreshTokenPayload = R.path(
                    ["auth", "refreshToken"],
                    data
                );

                const authProps = {
                    auth: null,
                    get isAuthenticated() {
                        return isAuthenticated(refreshTokenPayload);
                    },
                };

                if (authProps.isAuthenticated) {
                    const {
                        first_name,
                        last_name,
                        user_id,
                        username,
                    } = refreshTokenPayload;
                    // Set context for Sentry errors
                    const hasRaven = typeof Raven !== "undefined";
                    if (hasRaven) {
                        Raven.setUserContext({
                            user_id,
                            username,
                        });
                    }

                    authProps.auth = {
                        ...refreshTokenPayload,
                        displayName:
                            `${first_name} ${last_name}`.trim() ||
                            username.trim(),
                        accessToken: accessTokenPayload.raw,
                    };
                }

                return (
                    <Spin spinning={loading} tip="Loading...">
                        <WrappedComponent {...props} {...authProps} />
                    </Spin>
                );
            }}
        </Query>
    );

    component.displayName = `WithAuth(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        "WrappedComponent"})`;

    return component;
};

export default WithAuth;
